import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Badge } from "@/components/ui/badge";
import { Mail, Copy, ChevronDown, ChevronUp } from "lucide-react";

// Adresse d'import par e-mail de la gérance + journal des réceptions
export default function ImportEmailPanel() {
  const [info, setInfo] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => { api.get("/import/emails").then((r) => setInfo(r.data)).catch(() => {}); }, []);
  if (!info) return null;
  const copy = () => { navigator.clipboard?.writeText(info.adresse); toast.success("Adresse copiée"); };
  return (
    <div className="bg-white rounded-xl border border-dd-light p-5 mb-4" data-testid="import-email-panel">
      <div className="flex flex-wrap items-center gap-3">
        <div className="w-10 h-10 rounded-lg bg-dd-blue/10 flex items-center justify-center shrink-0"><Mail className="text-dd-blue" size={20} /></div>
        <div className="flex-1 min-w-[240px]">
          <div className="font-semibold text-dd-blue">Import par e-mail</div>
          <p className="text-xs text-dd-warm">Transférez vos scans (PDF, photos) à cette adresse depuis votre e-mail professionnel : ils arrivent ici, analysés, prêts à relire.</p>
        </div>
        <button onClick={copy} className="h-11 px-3 rounded-md border border-dd-light font-mono text-sm text-dd-night flex items-center gap-2 hover:bg-dd-light/60" data-testid="import-email-address">
          {info.adresse} <Copy size={14} className="text-dd-blue" />
        </button>
        {info.actif ? <Badge className="bg-dd-blue/10 text-dd-blue border-0" data-testid="import-email-status">Actif</Badge>
          : <Badge className="bg-amber-100 text-amber-900 border-0" data-testid="import-email-status">Activation en cours</Badge>}
      </div>
      {info.journal.length > 0 && (
        <div className="mt-3">
          <button onClick={() => setOpen((o) => !o)} className="text-sm text-dd-blue flex items-center gap-1" data-testid="import-email-journal-toggle">
            {open ? <ChevronUp size={14} /> : <ChevronDown size={14} />} Journal des réceptions ({info.journal.length})
          </button>
          {open && (
            <div className="mt-2 divide-y divide-dd-light text-sm">
              {info.journal.map((j, i) => (
                <div key={i} className="py-2 flex flex-wrap items-center gap-2" data-testid={`import-email-row-${i}`}>
                  <Badge className={`border-0 ${j.statut === "accepte" ? "bg-dd-blue/10 text-dd-blue" : "bg-destructive/10 text-destructive"}`}>{j.statut === "accepte" ? "Accepté" : "Refusé"}</Badge>
                  <span className="text-dd-night">{j.de}</span>
                  <span className="text-dd-warm truncate">— {j.sujet || "(sans sujet)"} · {j.motif}</span>
                  <span className="ml-auto text-xs text-dd-warm">{new Date(j.recu_le).toLocaleString("fr-CH")}</span>
                  {j.lot_id && <a href={`/constats/importer?lot=${j.lot_id}`} className="text-xs text-dd-blue underline">Ouvrir le lot</a>}
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
